export default {
  payChannel: 'Metody płatności',
  cashierDesk: 'Płatność',
  billAddress: 'Adres rozliczeniowy',
  paySuccess: 'Płatność udana',
  payError: 'Błąd płatności',
  harvestAddress: 'Adres dostawy',
  orderAddress: 'Adres rozliczeniowy',
  selectAddress: 'Wybierz adres dostawy',
  addOrderAddress: 'Dodaj najpierw adres rozliczeniowy',
  addSelectAddress: 'Wybierz adres dostawy',
  noAddress: 'Brak dostępnego adresu dostawy',
  holder: {
    inputPayPwd: 'Ustaw hasło płatności',
    returnExchange:
      'Płatność nie została zakończona. Nie można przetworzyć wniosku o zwrot/wymianę.',
  },
  transferTitle: 'Przelew bankowy',
  changeAddress: 'Zmień adres',
  editText: 'Edytuj',
  payWithbalance: 'Zapłać saldem acbuy',
  bankTransferRemittance: 'Przelew bankowy',
  transferTips:
    'Brak opłat serwisowych na acbuy za przelewy. Im wyższa kwota zamówienia, tym większe oszczędności!',
  pay: 'Oferty doładowań',
  plsSetPsd: 'Ustaw hasło płatności',
  thirdPayTips: 'Płatności są dostępne na całym świecie i w wielu walutach',
  payProcessing: 'Przetwarzanie płatności',
  payWaitingText: 'Spodziewaj się, że poczekasz 1-2 minuty, zapłać za wynik później',
  coinpalTips:
    'Doładowania waluty cyfrowej (wirtualnej) są bezzwrotne i nie można ich wypłacić. Jeśli to akceptujesz, prosimy o kontynuowanie doładowania.',
  payStatusTips: `Aún no hemos recibido el resultado de su pago. Por favor, confirme el estado de su pago.`,
  payErrorStatusTips: 'Płatność nie powiodła się. Spróbuj innej metody płatności.',
}
